"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaiaRef = exports.GaiaConfig = exports.Gaia = void 0;
var HttpSensorFunction_1 = require("./http/HttpSensorFunction");
var GaiaCredentials_1 = require("./api/GaiaCredentials");
var HttpSensorStream_1 = require("./http/HttpSensorStream");
var HttpClient_1 = require("./http/HttpClient");
var GaiaClientFactory_1 = require("./graphql/GaiaClientFactory");
var GaiaStreamClientBuilder_1 = require("./graphql/GaiaStreamClientBuilder");
var Gaia = /** @class */ (function () {
    function Gaia() {
    }
    Gaia.connect = function (value, credentials) {
        if (credentials && typeof value === 'string') {
            return new GaiaRef(new GaiaConfig(value, credentials, Gaia.clientFactory, Gaia.streamClientFactory));
        }
        // @ts-ignore
        return new GaiaRef(value);
    };
    Gaia.login = function (url, credentials) {
        return new HttpClient_1.HttpClient()
            .post(JSON.stringify(credentials), {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'true',
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }, url + '/api/auth/access')
            .then(function (response) {
            var cr = new GaiaCredentials_1.JWTCredentials(response.accessToken);
            return new GaiaRef(new GaiaConfig(url, cr, Gaia.clientFactory, Gaia.streamClientFactory, response.permissions));
        });
    };
    Gaia.clientFactory = new GaiaClientFactory_1.GaiaClientFactory();
    Gaia.streamClientFactory = new GaiaStreamClientBuilder_1.GaiaStreamClientFactory();
    return Gaia;
}());
exports.Gaia = Gaia;
var GaiaConfig = /** @class */ (function () {
    function GaiaConfig(url, credentials, clientFactory, streamClientFactory, permissions, functionProcessor, streamProcessor) {
        this.url = url;
        this.credentials = credentials;
        this.clientFactory = clientFactory;
        this.streamClientFactory = streamClientFactory;
        this.permissions = permissions || [];
        this.functionProcessor = functionProcessor || new HttpSensorFunction_1.HttpSensorFunction(url, credentials, this.clientFactory);
        this.streamProcessor = streamProcessor || new HttpSensorStream_1.HttpSensorStream(url, credentials, this.streamClientFactory);
    }
    return GaiaConfig;
}());
exports.GaiaConfig = GaiaConfig;
var GaiaRef = /** @class */ (function () {
    function GaiaRef(config) {
        var _this = this;
        this.data = function (uri) { return _this.sProc.data(uri); };
        this.skill = function (uri) { return _this.sProc.skill(uri); };
        this.identity = function () { return _this.sProc.identity(); };
        this.introspect = function (config) { return _this.fProc.introspect(config); };
        this.perceive = function (config) { return _this.fProc.perceive(config); };
        this.perceiveAction = function (impulse) { return _this.fProc.perceiveAction(impulse); };
        this.perceiveData = function (impulse) { return _this.fProc.perceiveData(impulse); };
        this.preserve = function (config) { return _this.fProc.preserve(config); };
        this.preserveCreateIdentities = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateIdentities.apply(_a, impulses);
        };
        this.preserveDeleteIdentities = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteIdentities.apply(_a, impulses);
        };
        this.preserveUpdateIdentities = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateIdentities.apply(_a, impulses);
        };
        this.preserveCreateTenants = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateTenants.apply(_a, impulses);
        };
        this.preserveDeleteTenants = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteTenants.apply(_a, impulses);
        };
        this.preserveUpdateTenants = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateTenants.apply(_a, impulses);
        };
        this.preserveCreateUsers = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateUsers.apply(_a, impulses);
        };
        this.preserveDeleteUsers = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteUsers.apply(_a, impulses);
        };
        this.preserveUpdateUsers = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateUsers.apply(_a, impulses);
        };
        this.preserveCreateApiKeys = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateApiKeys.apply(_a, impulses);
        };
        this.preserveDeleteApiKeys = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteApiKeys.apply(_a, impulses);
        };
        this.preserveUpdateApiKeys = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateApiKeys.apply(_a, impulses);
        };
        this.preserveCreateRoles = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateRoles.apply(_a, impulses);
        };
        this.preserveDeleteRoles = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteRoles.apply(_a, impulses);
        };
        this.preserveUpdateRoles = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateRoles.apply(_a, impulses);
        };
        this.preserveCreateIntents = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateIntents.apply(_a, impulses);
        };
        this.preserveDeleteIntents = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteIntents.apply(_a, impulses);
        };
        this.preserveUpdateIntents = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateIntents.apply(_a, impulses);
        };
        this.preserveCreatePrompts = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreatePrompts.apply(_a, impulses);
        };
        this.preserveDeletePrompts = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeletePrompts.apply(_a, impulses);
        };
        this.preserveUpdatePrompts = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdatePrompts.apply(_a, impulses);
        };
        this.preserveCreateStatements = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateStatements.apply(_a, impulses);
        };
        this.preserveDeleteStatements = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteStatements.apply(_a, impulses);
        };
        this.preserveUpdateStatements = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateStatements.apply(_a, impulses);
        };
        this.preserveCreateFulfilments = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateFulfilments.apply(_a, impulses);
        };
        this.preserveDeleteFulfilments = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteFulfilments.apply(_a, impulses);
        };
        this.preserveUpdateFulfilments = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateFulfilments.apply(_a, impulses);
        };
        this.preserveCreateBehaviours = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateBehaviours.apply(_a, impulses);
        };
        this.preserveDeleteBehaviours = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteBehaviours.apply(_a, impulses);
        };
        this.preserveUpdateBehaviours = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateBehaviours.apply(_a, impulses);
        };
        this.preserveCreateCodes = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateCodes.apply(_a, impulses);
        };
        this.preserveDeleteCodes = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteCodes.apply(_a, impulses);
        };
        this.preserveUpdateCodes = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateCodes.apply(_a, impulses);
        };
        this.preserveCreateEdges = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateEdges.apply(_a, impulses);
        };
        this.preserveDeleteEdges = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteEdges.apply(_a, impulses);
        };
        this.preserveCreateSkills = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateSkills.apply(_a, impulses);
        };
        this.preserveDeleteSkills = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteSkills.apply(_a, impulses);
        };
        this.preserveUpdateSkills = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateSkills.apply(_a, impulses);
        };
        this.preserveCreateSkillProvisions = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveCreateSkillProvisions.apply(_a, impulses);
        };
        this.preserveDeleteSkillProvisions = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveDeleteSkillProvisions.apply(_a, impulses);
        };
        this.preserveUpdateSkillProvisions = function () {
            var _a;
            var impulses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                impulses[_i] = arguments[_i];
            }
            return (_a = _this.fProc).preserveUpdateSkillProvisions.apply(_a, impulses);
        };
        this.preserveConnectNodeSet = function (nodeId, impulse) { return _this.fProc.preserveConnectNodeSet(nodeId, impulse); };
        this.preserveConnectNodeUnset = function (nodeId, impulse) { return _this.fProc.preserveConnectNodeUnset(nodeId, impulse); };
        this.preserveConnectNodeAppend = function (nodeId, impulse) { return _this.fProc.preserveConnectNodeAppend(nodeId, impulse); };
        this.preserveConnectNodeRemove = function (nodeId, impulse) { return _this.fProc.preserveConnectNodeRemove(nodeId, impulse); };
        this.retrieve = function (config) { return _this.fProc.retrieve(config); };
        this.retrieveBehaviours = function (identityId, config, limit, offset) { return _this.fProc.retrieveBehaviours(identityId, config, limit, offset); };
        this.retrieveBehaviour = function (identityId, reference, config) { return _this.fProc.retrieveBehaviour(identityId, reference, config); };
        this.retrieveCodes = function (identityId, config, limit, offset) { return _this.fProc.retrieveCodes(identityId, config, limit, offset); };
        this.retrieveCode = function (identityId, reference, config) { return _this.fProc.retrieveCode(identityId, reference, config); };
        this.retrieveExperience = function (config) { return _this.fProc.retrieveExperience(config); };
        this.retrieveFulfilments = function (identityId, config, limit, offset) { return _this.fProc.retrieveFulfilments(identityId, config, limit, offset); };
        this.retrieveFulfilment = function (identityId, reference, config) { return _this.fProc.retrieveFulfilment(identityId, reference, config); };
        this.retrieveIdentities = function (config, limit, offset) { return _this.fProc.retrieveIdentities(config, limit, offset); };
        this.retrieveIdentity = function (identityId, config) { return _this.fProc.retrieveIdentity(identityId, config); };
        this.retrieveTenant = function (tenantId, config) { return _this.fProc.retrieveTenant(tenantId, config); };
        this.retrieveTenants = function (config, limit, offset) { return _this.fProc.retrieveTenants(config, limit, offset); };
        this.retrieveUser = function (userId, config) { return _this.fProc.retrieveUser(userId, config); };
        this.retrieveUsers = function (config, limit, offset) { return _this.fProc.retrieveUsers(config, limit, offset); };
        this.retrieveApiKey = function (apiKeyId, config) { return _this.fProc.retrieveApiKey(apiKeyId, config); };
        this.retrieveApiKeys = function (config, limit, offset) { return _this.fProc.retrieveApiKeys(config, limit, offset); };
        this.retrieveRole = function (tenantId, roleId, config) { return _this.fProc.retrieveRole(tenantId, roleId, config); };
        this.retrieveRoles = function (tenantId, config, limit, offset) { return _this.fProc.retrieveRoles(tenantId, config, limit, offset); };
        this.retrieveIntents = function (identityId, config, limit, offset) { return _this.fProc.retrieveIntents(identityId, config, limit, offset); };
        this.retrieveIntent = function (identityId, reference, config) { return _this.fProc.retrieveIntent(identityId, reference, config); };
        this.retrieveKnowledge = function (config) { return _this.fProc.retrieveKnowledge(config); };
        this.retrieveEdges = function (source, config, limit, offset) { return _this.fProc.retrieveEdges(source, config, limit, offset); };
        this.retrieveEdge = function (source, edgeId, config) { return _this.fProc.retrieveEdge(source, edgeId, config); };
        this.retrievePrompts = function (identityId, config, limit, offset) { return _this.fProc.retrievePrompts(identityId, config, limit, offset); };
        this.retrievePrompt = function (identityId, reference, config) { return _this.fProc.retrievePrompt(identityId, reference, config); };
        this.retrieveStatements = function (identityId, config, limit, offset) { return _this.fProc.retrieveStatements(identityId, config, limit, offset); };
        this.retrieveStatement = function (identityId, reference, config) { return _this.fProc.retrieveStatement(identityId, reference, config); };
        this.retrieveSkills = function (tenantId, config, limit, offset) { return _this.fProc.retrieveSkills(tenantId, config, limit, offset); };
        this.retrieveSkill = function (tenantId, reference, config) { return _this.fProc.retrieveSkill(tenantId, reference, config); };
        this.retrieveSkillProvisions = function (tenantId, config, limit, offset) { return _this.fProc.retrieveSkillProvisions(tenantId, config, limit, offset); };
        this.retrieveSkillProvision = function (tenantId, reference, config) { return _this.fProc.retrieveSkillProvision(tenantId, reference, config); };
        this.retrieveBehaviourExecution = function (identityId, processInstanceId, config) { return _this.fProc.retrieveBehaviourExecution(identityId, processInstanceId, config); };
        this.retrieveBehaviourExecutions = function (identityId, config, limit, offset, startDate, endDate) { return _this.fProc.retrieveBehaviourExecutions(identityId, config, limit, offset, startDate, endDate); };
        this.retrieveIdentityMetrics = function (identityId, startDate, endDate, config, limit) { return _this.fProc.retrieveIdentityMetrics(identityId, startDate, endDate, config, limit); };
        this.introspectBuildJobs = function (tenantId, config) {
            if (config === void 0) { config = undefined; }
            return _this.fProc.introspectBuildJobs(tenantId, config);
        };
        this.practice = function (config) { return _this.fProc.practice(config); };
        this.practiceBuild = function (impulse, config) {
            if (config === void 0) { config = undefined; }
            return _this.fProc.practiceBuild(impulse, config);
        };
        this.practiceCancel = function (impulse, config) {
            if (config === void 0) { config = undefined; }
            return _this.fProc.practiceCancel(impulse, config);
        };
        this.config = config;
        this.fProc = config.functionProcessor;
        this.sProc = config.streamProcessor;
    }
    return GaiaRef;
}());
exports.GaiaRef = GaiaRef;
//# sourceMappingURL=Gaia.js.map